import { ComponentType, ReactNode } from 'react'
import { Box, SxProps } from '@mui/material'
import { Router, RouteComponentProps, Redirect, useLocation } from '@reach/router'

import Layout from 'src/components/Layout'
import Cades from 'src/components/shared/Cades'
import AvisosLexnet from 'src/components/views/AvisosLexnet'
import OpenEscrito from 'src/components/views/Escrito/OpenEscrito'
import Escritos from 'src/components/views/Escritos/Escritos'
import EscritosLexnet from 'src/components/views/EscritosLexnet/EscritosLexnet'
import LexonNotAuthenticated from 'src/components/views/LexonNotAuthenticated'
import Message from 'src/components/views/Message'
import Messages from 'src/components/views/Messages'
import PageNotFound from 'src/components/views/PageNotFound'
import * as routes from 'src/constants/routes'
import { TipoMensajeURLPath } from 'src/enums/EscritosLegales'
import CookiePolicy from '../views/CookiePolicy'

const routerStyle: SxProps = {
  overflow: 'hidden',
  height: '100vh',

  '&[data-scroll="true"]': {
    overflowY: 'auto'
  }
}

type Props = {
  component: ComponentType<any>
  children?: ReactNode
} & RouteComponentProps

function Route({ component: Component, ...rest }: Props) {
  return <Component {...rest} /> // eslint-disable-line react/jsx-props-no-spreading
}

const ESCRITOS = [
  TipoMensajeURLPath.TRAMITE,
  TipoMensajeURLPath.ASUNTO,
  TipoMensajeURLPath.EJECUCION,
  TipoMensajeURLPath.QUEJA,
  TipoMensajeURLPath.SENTENCIA,
  TipoMensajeURLPath.PERSONACION,
  TipoMensajeURLPath.MONITORIO
]

export default function RouterApp(): JSX.Element {
  const location = useLocation()
  const hasFooter =
    location.pathname === routes.MESSAGES() || location.pathname === routes.COOKIE_POLICY

  return (
    <Box
      component={Router}
      id="router"
      sx={routerStyle}
      display="flex"
      flexDirection="column"
      data-scroll={hasFooter}
    >
      <Route component={Layout} path="/">
        <Route component={Messages} path={routes.MESSAGES('')} exact />
        <Route component={Messages} path={routes.MESSAGES('pendientes')} exact />
        <Route component={Messages} path={routes.MESSAGES('firmadas')} exact />
        <Route component={Messages} path={routes.ACUSES('')} exact />
        <Route component={Messages} path={routes.ACUSES('pendientes')} exact />
        <Route component={Messages} path={routes.ACUSES('aceptados')} exact />
        <Route component={Messages} path={routes.ACUSES('rechazados')} exact />
        <Route component={Messages} path={routes.TRASLADOS} exact />
        <Route component={Escritos} path={routes.ESCRITOS('')} exact />
        <Route component={Escritos} path={routes.ESCRITOS('borradores')} exact />
        <Route component={Escritos} path={routes.ESCRITOS('sin-enviar')} exact />
        <Route component={Escritos} path={routes.ESCRITOS('enviados')} exact />
        <Route component={Escritos} path={routes.ESCRITOS('aceptados')} exact />
        <Route component={Escritos} path={routes.ESCRITOS('rechazados')} exact />
        <Route component={AvisosLexnet} path={routes.AVISOS_LEXNET()} exact />
        <Route component={OpenEscrito} path={routes.OPEN_ESCRITO} exact />
        <Route component={Message} path={routes.MESSAGE()} exact />
        {ESCRITOS.map(tipo => (
          <Route key={tipo} component={EscritosLexnet} path={routes.ESCRITOS_LEXNET(tipo)} exact />
        ))}
        <Route component={LexonNotAuthenticated} path={routes.NO_AUTH} exact />
        <Route component={Cades} path="/cades" exact />
        <Redirect from="/" to={routes.MESSAGES('')} exact noThrow />
        <Redirect from="/nuevo-escrito" to={routes.OPEN_ESCRITO} exact noThrow />
        <Route component={CookiePolicy} path={routes.COOKIE_POLICY} exact />
        <Route component={PageNotFound} default />
      </Route>
    </Box>
  )
}
